import React from 'react'
import LanguageSwitch from '@/components/LanguageSwitch'

class AnonymLayout extends React.Component {
  render () {
    return <div className='anonym-layout' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 20, width: '100%' }}>
      {/* background */}
      <div style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0, background: `url(/bg.jpg)`, backgroundSize: 'cover' }} />
      {this.props.children}
      <div className='language-switch'>
        <LanguageSwitch />
      </div>
    </div>
  }
}

export default AnonymLayout



// WEBPACK FOOTER //
// ./src/layouts/Anonymous/index.js